module.exports = function (isRegistrationNew) {
    return {
        event: 'BWSAUregistrationStart',
        eventContext: {
            registrationNew: isRegistrationNew
        }
    };
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/signup/atmmapper/registration-start.js
 **/